/* Parachilna — Buy panel assurances
   Keeps the stock row and the Klarna instalment in step with the selected
   variant. Dawn only re-renders #price-<section> and the submit button on a
   variant change, so these rows are ours to update.

   Data comes from the JSON blob the snippet prints (availability + the
   instalment already formatted by Liquid's `money` filter), keyed by variant id
   — no client-side currency maths, so the shop's format is always right.

   Primary signal is Dawn's 'variant-change' pub/sub event. Where that isn't
   available (quick-add, or a Dawn refactor), we fall back to reading the
   variant id straight off the product form. */
(function () {
  'use strict';

  function readData(root) {
    var script = root.querySelector('[data-pc-assurances-data]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('[pc-assurances] Could not parse variant data', error);
      return null;
    }
  }

  function apply(root, variantId) {
    var data = root.pcAssurancesData;
    if (!data) return;

    var variant = data.variants[String(variantId)];
    if (!variant) return;

    var stock = root.querySelector('[data-pc-stock]');
    if (stock) {
      // inStock is computed in Liquid as "tracked AND units on hand" — untracked
      // and continue-selling variants deliberately read as backorder.
      stock.classList.toggle('is-backorder', !variant.inStock);
      var text = stock.querySelector('[data-pc-stock-text]');
      if (text) text.textContent = variant.inStock ? data.inStockText : data.backorderText;
    }

    var amount = root.querySelector('[data-pc-klarna-amount]');
    if (amount && variant.instalment) amount.textContent = variant.instalment;
  }

  function currentVariantId(root) {
    var scope = root.closest('product-info') || root.closest('.product') || document;
    var input = scope.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? input.value : null;
  }

  function wire(root) {
    if (root.pcAssurancesReady) return;
    root.pcAssurancesReady = true;
    root.pcAssurancesData = readData(root);

    // Dawn publishes the resolved variant object on every option change.
    if (typeof subscribe === 'function') {
      subscribe('variant-change', function (event) {
        var variant = event && event.data && event.data.variant;
        if (!variant) return;
        // Ignore events from another product-info on the page (a quick-add modal
        // over a product page). Matched loosely in both directions because the
        // quick-add renders with a derived section id.
        var eventSection = event.data.sectionId;
        var mySection = root.dataset.sectionId;
        if (
          eventSection &&
          mySection &&
          eventSection.indexOf(mySection) === -1 &&
          mySection.indexOf(eventSection) === -1
        ) {
          return;
        }
        apply(root, variant.id);
      });
    }

    // Fallback: the hidden id input is updated by Dawn on every change too.
    var form = (root.closest('product-info') || document).querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );
    if (form) {
      new MutationObserver(function () {
        apply(root, form.value);
      }).observe(form, { attributes: true, attributeFilter: ['value'] });
    }

    var id = currentVariantId(root);
    if (id) apply(root, id);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pc-assurances]').forEach(wire);
  }

  // Exposed for the quick-add modal, which injects product HTML after load.
  window.pcInitBuyAssurances = init;

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
